
import { useState, useEffect, Fragment} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";
import FormatDecimal from "./FormatDecimal";


 

function InputComboStawkiDoc(props)
{

    var cData = Config.getFromBuffer(Config.cache_stawki_wyz,60, props.userData );   
    const [gr, setGr] = useState(cData);
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);     
    const [view, setView] = useState ( {
        v:'link',
        id: -1
    } );
    

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,st', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        setGr([]); 
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        setGr([]); 
                    }else    
                    {
                        setGr(res.result);      
                        
                        
                        Config.setToBuffer(Config.cache_stawki_wyz, res.result, props.userData);
                                
                    }
         } )
         .catch(err => {          
                    setGr([]); 
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   


    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGr(null);    
        }



 

    const onBack = (id) => {                 
                
        setGr(null);                 
        setView({
            v: 'link',
            id: -1
        });
    }


    const show = () => {
        setView({
            v: 'show',
            id: -1
        });
    }

    const hide = () => {
        setView({
            v: 'link',
            id: -1
        });
    }
      

    const onSelect = (e) => {

        var id = e.currentTarget.getAttribute("id");
    
        for(var k=0; k<gr.length; k++)
        {
            
            if(gr[k].v == id)
            {
                var record =  JSON.parse( JSON.stringify( gr[k].det));
                if(props.onSelect != undefined) props.onSelect(props.param, record);
                if(props.onSelect == undefined) console.log("brak onSelect");
            }
        }

        



        hide();
    }

    
    if( gr == null   )
    {      
        getGr();        
    }

 

    var dlg_view = null;

    if(view.v == "show")
    {


        var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                       Wybierz jedną z zapamiętanych pozycji
                    </div>


                    <div className="dlg_content_x">

                             <div className="form_tab">

                                        <div className="bg_center scroll150 nostick">                         
                                             
                                             <table className="table">
                                                       
                                                                {
                                                                    gr.map( (row, inx) => {

                                                                            var rowStyle = " row ";
                                                                            if(inx % 2 == 0 )rowStyle = " row2 "; 

                                                                            return <tr className={rowStyle + " link_normal"}  id={row.v} onClick={onSelect}>
                                                                                <td>
                                                                                    {row.title}
                                                                                </td>
                                                                                <td className="goright">
                                                                                    <FormatDecimal value={row.det.kwota_netto} />
                                                                                </td>
                                                                            </tr>

                                                                    } ) 
                                                                }
                                                        
                                             </table>                                               

                                        </div>


                                        <div className="form_split"></div>
                                        <br/>
                                        <div className="form_split"></div>
                                        <div className="btn" onClick={hide}>zamknij</div>

                             </div>

                    </div>
            </div>
        )



    }






    return  <span>
             <b className="link_color" onClick={show} >wybierz z listy</b> 
             {dlg_view}
    </span>
}


export default InputComboStawkiDoc;

